
export const DailyAssessmentPagination = ({ page, setPage, totalPages }) => {
  
  return (
    <div className="row text-center mt-2">
      <div className="col-12">
        <ul 
          className="pagination mb-0 list-unstyled flex-nowrap overflow-auto d-flex"
        >
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              {"<"}
            </button>
          </li>
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (item) => (
              <li
                className={`page-item ${page === item ? "active" : ""}`}
                key={item}
              >
                <button className="page-link" onClick={() => setPage(item)}>
                  {item}
                </button>
              </li>
            ),
          )}
          <li className="page-item">
            <button
              className={`page-link ${page === totalPages ? "disabled" : ""}`}
              aria-label="Next"
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages}
            >
              {">"}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};
